export const captureException = (_error, key, payload) => {
    return true
}
